import { render, staticRenderFns } from "./workandeducation.vue?vue&type=template&id=e1cf1326"
import script from "./workandeducation.vue?vue&type=script&lang=js"
export * from "./workandeducation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports